import { createFileRoute, redirect } from '@tanstack/react-router'

import { DeviceList } from '@/components/admin/device'
import { useAuth } from '@/hooks'

export const Route = createFileRoute('/_authenticated/admin/devices/' as never)({
  beforeLoad: ({ context }) => {
    const { user } = context as { user?: { role: string } }
    if (user && user.role !== 'admin' && user.role !== 'director') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/dashboard' })
    }
  },
  component: DevicesPage,
})

function DevicesPage() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">加载中...</div>
      </div>
    )
  }

  // 权限检查
  if (user?.role !== 'admin' && user?.role !== 'director') {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-destructive">您没有权限访问此页面</div>
      </div>
    )
  }

  return (
    <div className="container mx-auto py-6">
      <DeviceList />
    </div>
  )
}
